import { Box } from "@mui/material";
import { useEditorContext } from "features/editor/context/editor";

const Rule = ({ rule }: { rule: string }) => (
  <Box
    component="span"
    sx={{
      px: 0.4,
      color: "var(--status-color--error)",
      borderRadius: "3px",
    }}
    dangerouslySetInnerHTML={{ __html: rule }}
  />
);

export const Validation = () => {
  const { list, activeItemIndex } = useEditorContext();
  const validationErrors = list.items[activeItemIndex!]?.errors ?? [];

  if (!validationErrors?.length) {
    return <Box>Item is valid</Box>;
  }

  return (
    <Box sx={{ whiteSpace: "pre-line" }}>
      <Box component="ul" sx={{ m: 0, p: 0, fontSize: 14, "& .markdown-space": { opacity: 1 } }}>
        {validationErrors.slice(0, 10).map(({ rule, highlight }, index: number) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box component="li" key={rule + index} sx={{ mb: 1 }}>
            <Rule rule={rule} />
            {highlight ? <Box dangerouslySetInnerHTML={{ __html: highlight }} sx={{ pb: 1, pt: 0.3 }} /> : null}
          </Box>
        ))}
        {validationErrors.length > 10 && (
          <Box component="li" sx={{ mb: 1 }}>
            ... and {validationErrors.length - 10} more
          </Box>
        )}
      </Box>
    </Box>
  );
};
